import { AdminApi } from "../../core/api/AdminApi";

interface roleObj {
  roleName: string;
  roleId: number;
  brandSlug: string;
}

const ChatbotAPI = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatUserRoles: builder.query<roleObj[], void>({
      query: () => ({
        url: "/roles/my",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetChatUserRolesQuery
} = ChatbotAPI;